import { useEffect } from 'react';
import { usePopOutInstructionsLink } from 'store/pop-out-instructions';

/**
 * Auto-scrolls the popout instructions iframe when a step loads
 * if the iframe is already open with the same link
 */
export const useAutoScrollInstructions = (
  instructionsLink?: string,
  instructionsInnerHtmlToScroll?: string,
) => {
  const { popOutInstructionsLink, setPopOutInstructionsLink } =
    usePopOutInstructionsLink();

  useEffect(() => {
    if (
      instructionsLink &&
      instructionsInnerHtmlToScroll &&
      popOutInstructionsLink === instructionsLink
    ) {
      // Popout is already open with the same link, update innerHtmlToScroll to trigger scroll
      setPopOutInstructionsLink(
        instructionsLink,
        instructionsInnerHtmlToScroll || null,
      );
    }
  }, [
    instructionsLink,
    instructionsInnerHtmlToScroll,
    popOutInstructionsLink,
    setPopOutInstructionsLink,
  ]);
};
